const { connect } = require("react-redux");
const DialogActions = require("actions/dialog");
const CheckoutActions = require("actions/checkout");
const SnackbarActions = require("actions/snackbar");
const WhatsIncludedDialog = require("components/Dialog/WhatsIncludedDialog");

const internals = {};

internals.connect = connect(
    state => ({
        dialogOpen: state.dialog.isWhatsIncludedDialogOpen
    }),
    {
        displayError: SnackbarActions.messageSnackbar,
        onRequestDialogClose: () => {
            return dispatch => {
                dispatch(DialogActions.closeWhatsIncludedDialog());
                // We expect this to trigger a component unmount by nulling the transaction segment of redux state
                dispatch(CheckoutActions.endTransaction());
            };
        }
    }
);

module.exports = internals.connect(WhatsIncludedDialog);



// WEBPACK FOOTER //
// ./src/containers/WhatsIncludedDialog.js